<div *ngIf="canViewNotes" class="notes">
    <h3>Notes</h3>
    <div *ngFor="let note of notes">
        <div class="note">
            <div class="value">
                <p>{{ note.value }}</p>
            </div>
            <div class="actions-container">
                <div class="actions" [class.expanded]="note.showActions">
                    <button *ngIf="canDeleteNotes" class="button red" (click)="deleteNote(note)">Delete</button>
                </div>
            </div>
            <footer>
                <p>{{ note.userName }}</p>
                <p>{{ note.timeAdded | rf:'date' }}</p>
                <div *ngIf="canDeleteNotes" class="expander" (click)="toggleActions(note)">
                    <p *ngIf="!note.showActions; else minus">+</p>
                    <ng-template #minus>
                        <p>-</p>
                    </ng-template>
                </div>
            </footer>
        </div>
    </div>
    <div *ngIf="canAddNotes" class="addNote">
        <textarea type="text" [(ngModel)]="note" placeholder="New Note"></textarea>
        <button class="button green" [disabled]="!note.trim() || savingNote" (click)="addNote()">Add Note</button>
    </div>
</div>
